// @flow
import type { ReactComponentParams } from 'ko-component-react-component-placement/js/model';

export type CreateComponentProps<T = {}> = (name: string, model: T) => ReactComponentParams<T>;

export const createReactComponentModel: CreateComponentProps = (name, model) => ({
	name,
	eventEmitterName: 'JurdicalRegistration',
	entrypoints: '/media/sys-ng2/dist/entrypoints.json',
	model,
});

